import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "spork-reviews";
function getForm(axios, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: ["form"],
		queryString: buildQueryString(queryStringConfig),
		public: true
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function post(axios, publicSporkReviewId, body) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [publicSporkReviewId],
		public: true
	};

	const routePath = getRoutePath(config);

	return axios.post(routePath, body)
		.then(response => response.data);
}
export {
	getForm,
	post
};
